import { useMutation } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import type { SubmitFeedbackPayload } from './types';

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (body: SubmitFeedbackPayload) =>
      apiFetch<{ success: boolean }>('/feedback', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
  });
}
